"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.object.assign");

var _colors = require("@material-ui/core/colors");

var greyscale = Object.assign({}, _colors.grey, {
  black: _colors.common.black,
  white: _colors.common.white
});
var _default = greyscale;
exports["default"] = _default;